import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'containers/Femtasy';

import {
  getQuiz,
  QuizAnswer,
  resetQuiz,
  storeCurrentStep,
  storeQuiz,
} from 'store/modules/quizManager';

import { QuizStep } from './useQuizContext';

interface UseQuizLogicProps {
  steps: QuizStep[];
  quizId: string;
  trackingDetails?: {
    trackingEvent: string;
  };
}

const useQuizLogic = ({ steps, quizId }: UseQuizLogicProps) => {
  const dispatch = useDispatch();

  const quizData = useSelector((state: RootState) =>
    getQuiz({ state: state.quizManager, quizId }),
  );

  const { currentStep, responses } = quizData;

  const nextStep = (onNextCallback?: Function) => {
    if (currentStep < steps.length - 1) {
      dispatch(storeCurrentStep({ quizId, currentStep: currentStep + 1 }));

      if (onNextCallback) {
        onNextCallback();
      }
    }
  };

  const prevStep = (onPrevCallback?: Function) => {
    if (currentStep > 0) {
      dispatch(storeCurrentStep({ quizId, currentStep: currentStep - 1 }));

      if (onPrevCallback) {
        onPrevCallback();
      }
    }
  };

  const setQuizResponse = ({
    stepName,
    answer,
  }: {
    stepName: string;
    answer: QuizAnswer;
  }) => {
    dispatch(storeQuiz({ quizId, stepName, answer }));
  };

  const resetQuizData = () => {
    dispatch(resetQuiz(quizId));
  };

  return {
    currentStep,
    currentStepComponent: steps[currentStep],
    nextStep,
    prevStep,
    resetQuiz: resetQuizData,
    responses,
    setQuiz: setQuizResponse,
    totalSteps: steps.length,
  };
};

export default useQuizLogic;
